import { AccountInfoHeader } from './AccountInfoHeader';
import { connect } from 'react-redux';
import { userDataSel } from 'src/store/modules/user';
import { withI18n } from 'react-i18next';

const mapStateToProps = (state: any) => {
  return {
    userData: userDataSel(state)
  };
};

export const pureComponent = AccountInfoHeader;
export default connect(mapStateToProps, null)(withI18n()(AccountInfoHeader));
